export const TOKEN_EXPIRED = 'token_expired';

export default { TOKEN_EXPIRED };
